var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      key: _vm._key,
      attrs: { show: _vm.modalVisible, "modal-classes": "modal-lg" },
      on: {
        "update:show": function ($event) {
          _vm.modalVisible = $event
        },
        close: function ($event) {
          return _vm.$emit("closeClicked")
        },
      },
    },
    [
      _c("h4", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.modalTitle || "Select User") + " {"),
      ]),
      _c("UserPicker", {
        key: _vm._key,
        attrs: {
          _key: _vm._key,
          value: _vm.value,
          title: _vm.title,
          multi: _vm.multi,
          skipList: _vm.skipList,
          role: _vm.role,
          defaults: _vm.defaults,
        },
        on: {
          userSelected: _vm._onUserSelected,
          userRemoved: _vm._onUserRemoved,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }